"use strict";

export function handlePermission(callback){
  if (navigator.permissions) {
    navigator.permissions.query({name: 'geolocation'}).then(function (result) {
      //console.log(result);
      callback(result);
      result.onchange = function () {
        callback(result)
      };
    });
  } else {
    callback(null);
  }
}
